module.exports = __webpack_public_path__ + "img/Asset 2.2d6b5749.svg";